import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-password-requirements',
  templateUrl: './password-requirements.component.html',
  styleUrls: ['./password-requirements.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PasswordRequirementsComponent {
  @Input() control: AbstractControl | null = null;
}
